<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import UserLearningStylesResultsTable from "@/pages/Insights/ReportsDetailPage/components/UserLearningStylesResultsTable.vue";
import BaseResultsReport from "@/pages/Insights/ReportsDetailPage/components/BaseResultsReport.vue";
import { computed } from "vue";
import {useReportingStore} from "@/store/reporting";

const reportingState = useReportingStore();
reportingState.resetState();
reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "User Learning Styles", to: null }
]);
</script>

<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">

    <page-header
      title="User Learning Styles"
      description="Explore user Learning Styles results"
    />

    <BaseResultsReport
      data-endpoint="learning-styles-results"
      metric-endpoint="users-completed-learning-styles-ratio">
      <template #report-table="{ tableData }">
        <user-learning-styles-results-table
          :loading-data="false"
          :report-data="tableData"
          class="borderless"
        />
      </template>
    </BaseResultsReport>
  </authenticated-layout>
</template>

<style scoped>

</style>
